import AbstractUISlider, {UISLIDER_EVENTS} from "./AbstractUISlider";
import {ELEMENT_IDS} from "../MobileDOM";
import {ACTION_EVENTS} from "../../UserAction";
import events from "../../../events/EventsObservable";

class UISliderLines extends AbstractUISlider {

    constructor(wallet) {
        let slider = document.getElementById(ELEMENT_IDS.SLIDER_LINES);
        let value = wallet.getLinesCount();
        let allowedValues = wallet.getLines();
        let range = wallet.getLines();

        super(wallet, slider, range, value, allowedValues);

        events.subscribe(ACTION_EVENTS.ACTION_SLIDER_LINES_ON_SET, this);
    }

    notify(eventName: string, data?: any, prevData?: any): Promise<any>|void {
        switch (eventName) {
            case ACTION_EVENTS.ACTION_SLIDER_LINES_ON_SET:
                this._onSetEvent();
                break;
        }
    }

    _update({linesCount, lines = null}) {

        this.__update(linesCount, lines);

        events.dispatch(UISLIDER_EVENTS.UISLIDER_CHANGE_LINES, {linesCount, lines});

    }

}

export default UISliderLines;